import { Flex} from '@chakra-ui/react';
import { GiPill, GiWheat, GiFactory } from 'react-icons/gi';
import { MdGavel, MdSchool } from 'react-icons/md';
import { TbTruckDelivery } from 'react-icons/tb';

import './Section4.css';

function Section4() {
  const industries = [
    {
      name: 'Pharmaceuticals & Healthcare',
      icon: <GiPill size={40} color="#377DFF" />,
    },
    {
      name: 'Food & Agriculture',
      icon: <GiWheat size={40} color="#377DFF" />,
    },
    {
      name: 'Education & Training',
      icon: <MdSchool size={40} color="#377DFF" />,
    },
    {
      name: 'Manufacturing & Industrial',
      icon: <GiFactory size={40} color="#377DFF" />,
    },
    {
      name: 'Legal & Compliance',
      icon: <MdGavel size={40} color="#377DFF" />,
    },
    {
      name: 'Logistics & Supply Chain',
      icon: <TbTruckDelivery size={40} color="#377DFF" />,
    },
  ];

  return (
    <Flex className="section4-wrapper" direction="column" align="center">
      <div className="section4-title">
        Industries We Support
      </div>

      <div className="section4-grid">
        {industries.map((ind, i) => (
          <div key={i} className="industry-card">
            <div className="industry-icon">{ind.icon}</div>
            <div className="industry-name">{ind.name}</div>
          </div>
        ))}
      </div>
    </Flex>
  );
}

export default Section4;
